import { Dispatch } from 'redux';
import { signout } from '../../../../../actions/signout';
import CalendarIcon from '../../../../../design-system/icons/CalendarIcon';
import DashboardIcon from '../../../../../design-system/icons/DashboardIcon';
import MessageIcon from '../../../../../design-system/icons/MessageIcon';
import Routes from '../../../../../routes';
import { numberOfMissingInformationInProfileSelector } from '../../../../../selectors/profile';
import { t } from '../../../../../utils/translate';
import {
  isCompanyAdmin,
  isModerator,
  isMJGAdmin,
} from '../../../../../utils/typed/user';
import { HeaderConfigItem } from '../../@types/HeaderConfig.d';
import MainMenuItem from '../../components/main-menu-item/MainMenuItem';
import UsernavItem from '../../components/usernav-item/UsernavItem';
import translations from './professional.translations';

const config: { main: HeaderConfigItem[], connected: HeaderConfigItem[] } = {
  main: [
    {
      component: MainMenuItem,
      type: 'score',
      key: 'score',
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'dashboard',
      to: Routes.dashboard,
      label: t(translations.dashboard),
      icon: DashboardIcon,
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'conversations',
      to: Routes.conversations,
      label: t(translations.conversations),
      icon: MessageIcon,
      notificationKey: 'unreadMessageCount',
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'appointments',
      to: Routes.appointments,
      label: t(translations.appointments),
      icon: CalendarIcon,
    },
  ],
  connected: [
    {
      component: UsernavItem,
      type: 'link',
      key: 'profile',
      to: Routes.profile,
      label: t(translations.profile),
      isNotificationSelector: numberOfMissingInformationInProfileSelector,
    },
    {
      component: UsernavItem,
      type: 'link',
      key: 'settings',
      to: Routes.settings,
      label: t(translations.settings),
    },
    {
      component: UsernavItem,
      type: 'link',
      key: 'moderations',
      to: Routes.moderatorDashboard,
      label: t(translations.moderations),
      condition: ({ currentUser }) => !!currentUser && isModerator(currentUser),
    },
    {
      component: UsernavItem,
      type: 'link',
      key: 'fdr-configuration',
      to: Routes.mjgAdminFdrConfiguration,
      label: t(translations.fdrConfiguration),
      condition: ({ currentUser }) => !!currentUser && isMJGAdmin(currentUser),
    },
    {
      key: 'mjg-admin',
      component: UsernavItem,
      type: 'external-link',
      to: Routes.mjgAdminOnChronos,
      label: t(translations.mjgChronos),
      condition: ({ currentUser }) => !!currentUser && isMJGAdmin(currentUser),
    },
    {
      component: UsernavItem,
      type: 'action',
      key: 'logout',
      onClick: (dispatch: Dispatch) => { dispatch(signout(Routes.home)); },
      label: t(translations.logout),
    },
    {
      component: UsernavItem,
      type: 'switch-account',
      key: 'switch-account',
      to: Routes.companyAdminBase,
      label: t(translations.employeeMode),
      condition: ({ currentUser }) => !!currentUser && isCompanyAdmin(currentUser),
    },
  ],
};

export default config;
